const ENDPOINT = "https://us-central1-bxcoach-946f5.cloudfunctions.net/";
const EMAIL_URL = ENDPOINT + "sendMail";

export { EMAIL_URL };